export default __webpack_public_path__ + "static/media/icon-whatsapp.9d79c12f.svg";